import React from "react";
import { Box } from "../Box";
import { Menu } from "../../types/Menu";
import { NavAccordion } from "../NavAccordion";

interface Props {
  subArrow?: boolean;
  color?: string;
  myProfile?: boolean;
}

export const NavAccordionGroup: React.FC<Props & Menu> = ({
  menu,
  subArrow,
  color,
  myProfile,
}) => {
  if (!menu || !menu.length) {
    return null;
  }

  return (
    <>
      {menu.map(item => (
        <Box key={item.title} data-testid="NavAccordionGroup">
          {item.subMenu ? (
            <NavAccordion
              {...item}
              arrow={subArrow}
              color={color}
              subMenu
              myProfile={myProfile}
              key={item.title}
            >
              <NavAccordionGroup
                menu={item.subMenu}
                color={item.subMenu[0].backgroundColor}
                subArrow
                myProfile={myProfile}
              />
            </NavAccordion>
          ) : (
            <NavAccordion
              key={item.title}
              color={color}
              {...item}
              subMenu={false}
              myProfile={myProfile}
            />
          )}
        </Box>
      ))}
    </>
  );
};

NavAccordionGroup.defaultProps = {
  subArrow: false,
  color: "primary",
  myProfile: false,
};
